import request from '@/utils/request'

const http = request()

export const roleList = params => http.post('/system/role/list', params)

export const saveRole = params => http.post('/system/role/save', params)

export const updateRole = params => http.post('/system/role/update', params)

export const getRole = roleId => http.get('/system/role/' + roleId)

export const deleteRole = roleId => http.get('/system/role/delete/' + roleId)

export const saveRoleMenu = (roleId, menuIds, projectTypes) => http.post('/system/rolemenu/batch-save', { roleId, menuIds, projectTypes })

export const getMenuIdsByRole = roleId => http.post('/system/rolemenu/menu-ids', { roleId })

export const getRoleProjectTypes = roleId => http.post('/system/role/projectTypes', { roleId })
